var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".notifications_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 17.5V11a8.5 8.5 0 0 0-5.541-7.959 3 3 0 0 0-5.922 0A8.49 8.49 0 0 0 3.5 11v6.5a3 3 0 0 1-3 3h23a3 3 0 0 1-3-3M15 20.5a3 3 0 1 1-6 0",
    className: "notifications_svg__a"
  })));
};
export default SvgNotifications;